/*******************************************/
/*** File with various JS helper methods ***/
/*******************************************/
// c241021 by nr

import { DirectUpload } from "@rails/activestorage"

export function generate_pdf_from_table(table, doc_title, doc_subtitle, employee_name, excluded_columns = []) {
    // Use jsPDF library
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();
  
    // Get current date
    const current_date = new Date().toLocaleDateString("de-DE");
  
    // Add header and footer with hooks provided by autoTable
    const img_path = window.badok_logo_path;
  
    // Handle either a selector or a DOM element as `table`
    let original_table;
    if (typeof table === 'string') {
      // If a selector is provided, use querySelector to get the table element
      original_table = document.querySelector(table);
    } else if (table instanceof HTMLElement) {
      // If a table element is directly provided, use it
      original_table = table;
    }
  
    // Clone the original table
    const cloned_table = original_table.cloneNode(true);
  
    // Remove specified columns from the cloned table
    if (excluded_columns.length > 0) {
      cloned_table.querySelectorAll('tr').forEach(row => {
        excluded_columns.forEach(col_index => {
          const cell = row.children[col_index];
          if (cell) {
            cell.remove(); // Remove the cell if it exists
          }
        });
      });
    }
  
    // Create a variable to store the total number of pages
    let page_count = 0;
	var totalPagesExp = "{total_pages_count_string}";
  
    // Match jsPDF-AutoTable default horizontal margin (see parseInput: parseSpacing(margin, 40/scaleFactor))
    const sideMargin = 40 / doc.internal.scaleFactor;
    const pageWidth =
      typeof doc.internal.pageSize.getWidth === "function"
        ? doc.internal.pageSize.getWidth()
        : doc.internal.pageSize.width;
    const pageCenterX = pageWidth / 2;
    const contentWidth = pageWidth - sideMargin * 2;

    const titleBaselineY = 30;
    doc.setFontSize(14);
    const titleLines = doc.splitTextToSize(doc_title, contentWidth);
    const titleLineHeight = doc.getLineHeight() / doc.internal.scaleFactor;

    doc.setFontSize(8);
    const subtitleLines = doc.splitTextToSize(String(doc_subtitle || ""), contentWidth);
    const subtitleLineHeight = doc.getLineHeight() / doc.internal.scaleFactor;

    const gapTitleToSubtitle = 1.5;
    const subtitleBaselineY =
      titleBaselineY + titleLines.length * titleLineHeight + gapTitleToSubtitle;
    const clearanceBeforeTable = 4;
    const headerBottom =
      subtitleBaselineY + subtitleLines.length * subtitleLineHeight;
    const tableMarginTop = Math.max(45, headerBottom + clearanceBeforeTable);

    const tableMargin = Object.assign(
      { top: 45, left: sideMargin, right: sideMargin, bottom: sideMargin },
      window.badok_autotable_style.margin || {},
      { top: tableMarginTop, left: sideMargin, right: sideMargin }
    );

    // Use autoTable to generate the table and calculate the total number of pages
    doc.autoTable({
      html: cloned_table,
      ...window.badok_autotable_style,
      margin: tableMargin,
      didDrawPage: function (data) {
        // Only add the header on the first page
        if (data.pageNumber === 1) {
          // Custom header with title
          doc.addImage(img_path, 'PNG', 10, 10, 30, 11); // Adjust logo position and size
  
          // Set font size, and color for the heading
          doc.setFontSize(14);      // Set the font size to 14pt
          doc.setTextColor(70, 110, 160); // Set the color to #466ea0 (RGB: 70, 110, 160)
  
          // Add the title (wrapped to the same width as the table body)
          doc.text(titleLines, pageCenterX, titleBaselineY, { align: "center" });
  
          // Set font back to normal for the other text
          doc.setFontSize(8);
          doc.setTextColor(51, 51, 51); // Default color back to black

				doc.text(subtitleLines, pageCenterX, subtitleBaselineY, {
					align: "center",
				});
  
          // Only print "von user_name" if user_name is not null
				let user_name_text = employee_name ? ` von ${employee_name}` : "";
				doc.text(
					`VERTRAULICHE INFORMATIONEN gedruckt${user_name_text} am ${current_date}`,
					pageWidth - 10,
					20,
					{ align: "right" }
				);
        }
  
        // Custom footer
        const page_size = doc.internal.pageSize;
			  const page_height = page_size.height
          ? page_size.height
          : page_size.getHeight();

        // Set font back to normal for the other text
        doc.setFontSize(8);
        doc.setTextColor(51, 51, 51); // Default color back to black
  
        // Add page number at the bottom center
        const page_number = data.pageNumber;  // X
        if (!page_count) {
          page_count = doc.internal.getNumberOfPages();  // Y (total number of pages)
        }
			doc.text(
				`Seite ${page_number} von ${totalPagesExp}`,
				page_size.width / 2,
				page_height - 10,
				{ align: "center" }
			);
  
        // Add custom footer text on the left bottom
        doc.text(`badok`, 10, page_height - 10);
  
        // Add the document title to the right in the footer
        doc.text(`${doc_title}`, doc.internal.pageSize.width - 10, page_height - 10, { align: 'right' });
      }
    });

    if (typeof doc.putTotalPages === "function") {
      doc.putTotalPages(totalPagesExp);
    }
  
    // Save the PDF with the current date in the filename
    const file_name = `${doc_title} ${current_date}.pdf`;
    doc.save(file_name);
}

  

/* global badok style for tables (using jsPDF & autotable) in generated PDFs */
window.badok_autotable_style = {
    headStyles: {
      fillColor: [221, 221, 221],   // Header background (hex #ddd)
      textColor: [70, 92, 153],     // Header text color (hex #465C99)
      fontSize: 10,                 // Font size for header
      fontStyle: 'bold',            // Bold header font
      halign: 'left',               // Left-align header text
      valign: 'middle'              // Vertically align text in the middle
    },
    bodyStyles: {
      fontSize: 10,                 // Regular font size for body rows
      textColor: [51, 51, 51],   // Row text color (hex #666666)
      fillColor: [255, 255, 255],   // Row background (white)
      halign: 'left',               // Left-align body text
      valign: 'middle',             // Vertically align text in the middle
      cellPadding: 3                // Add padding to the cells
    },
    alternateRowStyles: {
      fillColor: [255, 255, 255]    // Keep all rows with a white background
    },
    margin: { top: 45 },            // Add margin at the top of the table
    theme: 'striped',               // Grid style for the table
    showHead: 'everyPage',          // Show header on every page
    tableLineWidth: 0,              // No table border
    tableLineColor: null,           // Ensure no color is applied to borders
    styles: {
      overflow: 'linebreak',        // Break long text into new lines within the cell
      fontSize: 10                  // Font size for table content
    },
    didDrawCell: function (data) {
      // Only draw horizontal lines between rows
      if (data.row.index < data.table.body.length - 1) {
        var doc = data.doc;
        var startX = data.cell.x;
        var startY = data.cell.y + data.cell.height;
        var endX = data.cell.x + data.cell.width;
        doc.setLineWidth(1);
        doc.setDrawColor(147, 193, 246);
        doc.line(startX, startY, endX, startY); // Draw the horizontal line
      }
    }
};

/* ========= reusable direct-upload drag & drop ========= */
function closest_dropzone(el) {
	return el.closest('[data-direct-upload-dropzone]');
}

function get_state(drop_area) {
	const max_files = parseInt(drop_area.dataset.maxFiles || "1", 10);
	const upload_target_selector = drop_area.dataset.uploadTarget || null;
	return { max_files, upload_target_selector };
}

function set_progress(drop_area, visible, percent) {
	const progress_wrapper = drop_area.querySelector(".upload_progress");
	const progress_bar = drop_area.querySelector(".progress_bar");
	if (!progress_wrapper || !progress_bar) return;

	progress_wrapper.style.display = visible ? "block" : "none";
	if (visible) progress_bar.style.width = `${percent || 0}%`;
}

/* ---- reusable dropzone messaging (no form specifics) ---- */
function set_dropzone_message(drop_area, visible, text) {
	const message = drop_area.querySelector(".upload_message");
	if (!message) return;

	if (visible) {
		if (text != null) message.textContent = text;
		message.style.display = "block";
	} else {
		message.style.display = "none";
	}
}

function set_dropzone_reached_max(drop_area, reached) {
	if (reached) {
		set_dropzone_message(drop_area, true, "Maximale Anzahl an Dateien erreicht.");
		drop_area.classList.add("is_disabled");
	} else {
		set_dropzone_message(drop_area, true, "Datei per Drag & Drop hier ablegen oder zum Hochladen klicken");
		drop_area.classList.remove("is_disabled");
	}
}

// expose for page-specific JS (js_attachments)
window.set_dropzone_reached_max = set_dropzone_reached_max;
window.set_dropzone_message = set_dropzone_message;


/* ---- one file upload ---- */
function upload_one_file(file, input, drop_area, state, index, total, on_progress) {
	return new Promise((resolve, reject) => {
		const form = input.closest("form");
		const upload = new DirectUpload(file, input.dataset.directUploadUrl);

		// IMPORTANT: hook when XHR is created
		upload.delegate = {
			directUploadWillStoreFileWithXHR: (xhr) => {
				xhr.upload.addEventListener("progress", (e) => {
					if (!e.lengthComputable) return;

					// report bytes upward
					if (on_progress) on_progress(e.loaded, e.total);

					// optional per-file event
					const percent = Math.round((e.loaded / e.total) * 100);
					drop_area.dispatchEvent(new CustomEvent("direct-upload:progress", {
						bubbles: true,
						detail: { file, percent, index, total }
					}));
				});
			}
		};

		upload.create((error, blob) => {
			if (error) return reject(error);

			const hidden = document.createElement("input");
			hidden.type = "hidden";
			hidden.name = input.name;
			hidden.value = blob.signed_id;
			form.appendChild(hidden);

			drop_area.dispatchEvent(new CustomEvent("direct-upload:file-done", {
				bubbles: true,
				detail: {
					file,
					signed_id: blob.signed_id,
					index,
					total,
					upload_target_selector: state.upload_target_selector
				}
			}));

			resolve(blob);
		});
	});
}



/* ---- batch upload drag-and-drop ---- */
export function upload_file_drag_drop(files, input) {
	const drop_area = input.closest("[data-direct-upload-dropzone]");
	const state = get_state(drop_area);

	const file_list = Array.from(files || []);
	if (file_list.length === 0) return;

	const form = input.closest("form");

	// count already queued uploads generically:
	// hidden inputs with the same "name" as the file input
	const existing_count = form.querySelectorAll(`input[type="hidden"][name="${input.name}"]`).length;

	const max_files = state.max_files;
	const available_slots = Math.max(max_files - existing_count, 0);

	if (available_slots === 0) {
		// already at max -> show max message
		set_dropzone_reached_max(drop_area, true);
		return;
	}

	// limit to available slots (not just max_files)
	const to_upload = file_list.slice(0, available_slots);

	// if nothing to upload after slicing, show max
	if (to_upload.length === 0) {
		set_dropzone_reached_max(drop_area, true);
		return;
	}

	// reset to normal message state, then hide while uploading
	set_dropzone_reached_max(drop_area, false);
	set_dropzone_message(drop_area, false);

	// notify start (only if we actually upload something)
	drop_area.dispatchEvent(new CustomEvent("direct-upload:batch-start", {
		bubbles: true,
		detail: { total: to_upload.length }
	}));

	set_progress(drop_area, true, 0);
	input.value = ""; // allow same file re-pick

	const total_files = to_upload.length;

	// seed totals immediately with file sizes
	const per_file_loaded = new Array(total_files).fill(0);
	const per_file_total  = to_upload.map((f) => f.size);

	const update_aggregate_progress = () => {
		const loaded_sum = per_file_loaded.reduce((a, b) => a + b, 0);
		const total_sum  = per_file_total.reduce((a, b) => a + b, 0) || 1;

		const percent = Math.round((loaded_sum / total_sum) * 100);
		set_progress(drop_area, true, percent);

		drop_area.dispatchEvent(new CustomEvent("direct-upload:batch-progress", {
			bubbles: true,
			detail: { percent, loaded_sum, total_sum }
		}));
	};

	// show 0% of known total right away
	update_aggregate_progress();

	const upload_promises = to_upload.map((file, idx) => {
		return upload_one_file(
			file,
			input,
			drop_area,
			state,
			idx,
			total_files,
			(loaded, total) => {
				per_file_loaded[idx] = loaded;

				// only replace seeded total if we get a real one
				if (total && total > 0) per_file_total[idx] = total;

				update_aggregate_progress();
			}
		);
	});


	Promise.all(upload_promises)
		.then(() => {
			set_progress(drop_area, false);

			const new_existing = form.querySelectorAll(`input[type="hidden"][name="${input.name}"]`).length;
			set_dropzone_reached_max(drop_area, new_existing >= max_files);

			drop_area.dispatchEvent(new CustomEvent("direct-upload:batch-done", {
				bubbles: true,
				detail: { total: total_files }
			}));
		})
		.catch((err) => {
			set_progress(drop_area, false);

			const new_existing = form.querySelectorAll(`input[type="hidden"][name="${input.name}"]`).length;
			set_dropzone_reached_max(drop_area, new_existing >= max_files);

			drop_area.dispatchEvent(new CustomEvent("direct-upload:batch-error", {
				bubbles: true,
				detail: { error: err }
			}));
		});
}



/* ========= drag-drop listeners (reusable) ========= */

document.addEventListener("click", (event) => {
	const drop_area = closest_dropzone(event.target);
	if (!drop_area) return;

	const input = drop_area.querySelector("input[type='file'][data-direct-upload-url]");
	if (!input) return;

	if (event.target.closest("a, button, input, label")) return;
	input.click();
});

["dragover", "dragenter"].forEach((evt) => {
	document.addEventListener(evt, (event) => {
		const drop_area = closest_dropzone(event.target);
		if (!drop_area) return;

		event.preventDefault();
		event.stopPropagation();
		drop_area.classList.add("dragover");
	});
});

["dragleave", "dragend", "drop"].forEach((evt) => {
	document.addEventListener(evt, (event) => {
		const drop_area = closest_dropzone(event.target);
		if (!drop_area) return;

		event.preventDefault();
		event.stopPropagation();
		drop_area.classList.remove("dragover");
	});
});

document.addEventListener("drop", (event) => {
	const drop_area = closest_dropzone(event.target);
	if (!drop_area) return;

	const input = drop_area.querySelector("input[type='file'][data-direct-upload-url]");
	if (!input) return;

	const files = event.dataTransfer && event.dataTransfer.files;
	if (!files || files.length === 0) return;

	upload_file_drag_drop(files, input);
});

document.addEventListener("change", (event) => {
	const input = event.target;
	if (!input.matches("[data-direct-upload-dropzone] input[type='file'][data-direct-upload-url]")) return;
	if (!input.files || input.files.length === 0) return;

	upload_file_drag_drop(input.files, input);
});



/* Badok Accordion Animation */
function set_badok_accordion_state(summary, panel, is_open) {
	if (!summary || !panel) return;

	summary.classList.toggle('is-open', is_open);
	panel.classList.toggle('is-open', is_open);
	summary.setAttribute('aria-expanded', is_open ? 'true' : 'false');

	var icon = summary.querySelector('.js-badok-accordion-icon');
	if (icon) {
		icon.classList.toggle('fa-plus-circle', !is_open);
		icon.classList.toggle('fa-minus-circle', is_open);
	}

	var title = summary.querySelector('.js-badok-accordion-title');
	if (title) {
		title.classList.toggle('h3size', !is_open);
		title.classList.toggle('h5size', is_open);
	}

	// Let title/font changes apply first, then animate panel height with fresh scrollHeight.
	window.requestAnimationFrame(function () {
		panel.style.maxHeight = is_open ? (panel.scrollHeight + 'px') : '0px';
	});
}

window.badokAccordionSetOpen = function(summary_or_selector, is_open) {
	var summary = typeof summary_or_selector === 'string'
		? document.querySelector(summary_or_selector)
		: summary_or_selector;
	if (!summary) return;

	var target_selector = summary.dataset.target;
	if (!target_selector) return;

	var panel = document.querySelector(target_selector);
	if (!panel) return;

	set_badok_accordion_state(summary, panel, !!is_open);
};

document.addEventListener('click', function (e) {
	var summary = e.target.closest('.badok_accordion_summary');
	if (!summary) return; // click was not on a summary

	e.preventDefault();

	var target_selector = summary.dataset.target;
	var panel = document.querySelector(target_selector);
	if (!panel) return;

	var is_open = !panel.classList.contains('is-open');
	set_badok_accordion_state(summary, panel, is_open);
});

document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.badok_accordion_summary').forEach(function (summary) {
		var target_selector = summary.dataset.target;
		if (!target_selector) return;
		var panel = document.querySelector(target_selector);
		if (!panel) return;
		set_badok_accordion_state(summary, panel, panel.classList.contains('is-open'));
	});
});



/* Two Step Button */
(function() {
	function two_step_safe_eval(js_string, el) {
		if (!js_string) return;
		try {
			(new Function(js_string)).call(el);
		} catch (e) {
			if (window.console && console.error) console.error(e);
		}
	}

	function two_step_set_button_state(btn, step) {
		if (step === 1) {
			btn.dataset.step = "1";
			btn.textContent = btn.dataset.primaryText || "";
			btn.className = "js-two-step-button " + (btn.dataset.primaryClass || "");
			btn.setAttribute("style", btn.dataset.primaryStyle || "");
			return;
		}

		btn.dataset.step = "2";
		btn.textContent = btn.dataset.confirmText || "";
		btn.className = "js-two-step-button " + (btn.dataset.confirmClass || "");
		btn.setAttribute("style", btn.dataset.confirmStyle || "");
	}

	// capture=true ensures we intercept BEFORE rails-ujs/jquery-ujs
	document.addEventListener("click", function(e) {
		var btn = e.target.closest("a.js-two-step-button[data-two-step-button='1']");
		if (!btn) return;

		var step = String(btn.dataset.step || "1");
		var href = String(btn.getAttribute("href") || "#");

		if (step === "1") {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();

			two_step_safe_eval(btn.dataset.onFirstClick, btn);
			two_step_set_button_state(btn, 2);

			btn.blur();

			var timeout_ms = parseInt(btn.dataset.confirmTimeoutMs, 10);
			if (!isNaN(timeout_ms) && timeout_ms > 0) {
				window.setTimeout(function() {
					if (String(btn.dataset.step) === "2") two_step_set_button_state(btn, 1);
				}, timeout_ms);
			}

			return;
		}

		// step 2
		two_step_safe_eval(btn.dataset.onConfirm, btn);

		// pure JS (no url)
		if (!href || href === "#") {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			two_step_set_button_state(btn, 1);
			return;
		}

		// allow UJS to proceed on step 2
		two_step_set_button_state(btn, 1);
	}, true);
})();